import { axiosInstanceV1 } from "@rentablo/api";
import { User, SignupAttributes } from "../model";

export const signup = async ({
  skipSessionLogin,
  ...attrs
}: SignupAttributes) => {
  const { data } = await axiosInstanceV1.post<User>(`/signup`, attrs);
  return data;
};
